"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var banali_react_leaflet_1 = require("banali-react-leaflet");
var leaflet_1 = __importDefault(require("leaflet"));
var GoogleGeocoding_1 = __importDefault(require("../../../../constants/GoogleGeocoding"));
var use_supercluster_1 = __importDefault(require("use-supercluster"));
var mapHelpers_1 = require("../../../../helpers/mapHelpers");
var MarkerInfoWindow_1 = __importDefault(require("../../../../features/google/MarkersWrapper/MemoizedMarker/MarkerInfoWindow"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Cluster = react_1.forwardRef(function (_a, mapRef) {
    var markers = _a.markers, onMarkerSelect = _a.onMarkerSelect;
    var map = banali_react_leaflet_1.useMap();
    var renderIcon = mapHelpers_1.LeafLetDivIcon();
    var _b = react_1.useState([
        0, 55, 0, 0,
    ]), bounds = _b[0], setBounds = _b[1];
    var _c = react_1.useState(13), zoom = _c[0], setZoom = _c[1];
    var geoJSONPlaces = react_1.useMemo(function () {
        return markers.map(function (place) {
            var geoJSONPlace = {};
            geoJSONPlace.type = 'Feature';
            geoJSONPlace.properties = {
                cluster: false,
                id: place.id,
            };
            geoJSONPlace.geometry = {
                type: 'Point',
                coordinates: [
                    place.location.coordinates[1],
                    place.location.coordinates[0],
                ],
            };
            geoJSONPlace.marker = place;
            geoJSONPlace.deal = place.deal;
            return geoJSONPlace;
        });
    }, [markers]);
    banali_react_leaflet_1.useMapEvents({
        moveend: function () {
            updateMap(map);
        },
    });
    var _d = use_supercluster_1.default({
        points: geoJSONPlaces,
        bounds: bounds,
        zoom: zoom,
        options: { radius: 150, maxZoom: 14 },
    }), clusters = _d.clusters, supercluster = _d.supercluster;
    var updateMap = function (map) {
        setBounds([
            map.getBounds().getSouthWest().lng,
            map.getBounds().getSouthWest().lat,
            map.getBounds().getNorthEast().lng,
            map.getBounds().getNorthEast().lat,
        ]);
        setZoom(map.getZoom());
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, clusters.map(function (cluster, index) {
        // every cluster point has coordinates
        var _a = cluster.geometry.coordinates, longitude = _a[0], latitude = _a[1];
        // the point may be either a cluster or a crime point
        var _b = cluster.properties, isCluster = _b.cluster, pointCount = _b.point_count;
        // we have a cluster to render
        if (isCluster) {
            return (react_1.default.createElement(banali_react_leaflet_1.Marker, { key: index, position: [latitude, longitude], icon: renderIcon(Number(pointCount), styles_module_scss_1.default.cluster_marker), onClick: function () {
                    var _a;
                    var expansionZoom = Math.min(supercluster.getClusterExpansionZoom(cluster.id), 14);
                    var leaflet = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.leafletElement;
                    leaflet.setView([latitude, longitude], expansionZoom, {
                        animate: true,
                    });
                } }));
        }
        // we have a single point to render
        return (react_1.default.createElement(banali_react_leaflet_1.Marker, { key: cluster.properties.id, position: [latitude, longitude], icon: leaflet_1.default.icon({
                iconSize: [25, 41],
                popupAnchor: [2, -40],
                iconUrl: GoogleGeocoding_1.default.MAP.TYPE_TO_MARKER[cluster === null || cluster === void 0 ? void 0 : cluster.deal],
            }), eventHandlers: {
                mouseover: function (event) { return event.target.openPopup(); },
                mouseout: function (event) { return event.target.closePopup(); },
                click: function () { return onMarkerSelect(cluster.marker); },
            } },
            react_1.default.createElement(banali_react_leaflet_1.Popup, null,
                react_1.default.createElement(MarkerInfoWindow_1.default, { selectedMarker: cluster.marker }))));
    })));
});
exports.default = Cluster;
